import React from 'react'
import { useHistory } from 'react-router-dom'
import BackIcon from '../../assets/icons/back.svg'
import { Icon } from '../../styles/image'

export default ({ onClick, isGiftPage, ...rest }) => {
  const history = useHistory()
  const isGiftPaid =
    history && history.location &&
    history.location.pathname && history.location.pathname.includes('/gift/paid') &&
    history.location.state && history.location.state.from && history.location.state.from.includes('/gift/pay')

  const backClick = () =>
    isGiftPaid ?
      history.go(-2)
      :
      history.goBack()


  return (
    <Icon
      width="25px"
      isLink
      alt=""
      src={BackIcon}
      isBright={isGiftPage}
      onClick={onClick || backClick}
      {...rest}
    />
  )
}